import { AppDispatch } from '@/root/store';
import { ShowEvent } from '@/services/events';
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation, useParams } from 'react-router-dom';
import { SectionItem, SectionTabs } from '../../_nav/section';

const sections: Record<string, string> = {
  info: 'Informasi acara',
  ots: 'Sistem OTS',
  ticket: 'Daftar tiket',
  transaction: 'Daftar transaksi',
  attendee: 'Daftar peserta',
  commerce: 'Keuangan',
  marketing: 'Marketing',
  settings: 'Pengaturan',
};

// Helper function to get visible sections based on role
const getVisibleSections = (
  role: string | undefined
): Record<string, string> => {
  if (!role) return sections;

  const visibleSections = { ...sections };

  // Hide OTS for scanner & finance
  if (role === 'scanner' || role === 'finance') {
    delete visibleSections.ots;
  }

  // Show commerce (Keuangan) only for finance, owner, and superadmin
  const allowedCommerceRoles = ['finance', 'owner', 'superadmin'];
  if (!allowedCommerceRoles.includes(role)) {
    delete visibleSections.commerce;
  }

  return visibleSections;
};

export function OrgEventDetailLayout() {
  const location = useLocation();
  const dispatch: AppDispatch = useDispatch();
  const { slug } = useParams();

  const pathArray = location.pathname.split('/').slice(3);
  const section = pathArray[0];

  const { event, onEventUpdated } = useSelector((state: any) => state.event);

  const visibleSections = useMemo(() => {
    return getVisibleSections(event?.logged_in_organizer?.role);
  }, [event?.logged_in_organizer?.role]);

  useEffect(() => {
    dispatch(ShowEvent(slug));
  }, [slug, onEventUpdated]);

  return !section ? (
    <Navigate to='info' />
  ) : (
    <>
      <SectionTabs>
        {Object.entries(visibleSections).map(([key, value]) => {
          return (
            <SectionItem
              id={key}
              key={key}
              name={value}
              isCurrent={section === key}
            />
          );
        })}
      </SectionTabs>
      <Outlet />
    </>
  );
}
